import types from '../actions/types';
import abilities from '../abilities';
import createReducer from '../utils/createReducer';

const initialState = {
  token: null,
  isLoggingIn: false,
  isImpersonating: false,
  user: {
    name: 'Visitante',
    email: 'Visitante',
    accessProfile: 'Visitante',
  },
  originalUser: null,
};

const loginRequestCase = state => ({
  ...state,
  isLoggingIn: true,
});

const fetchCurrentUserSuccess = (state, action) => {
  const {
    id,
    name,
    email,
    accessProfile,
    token,
    isImpersonating,
    originalUser,
  } = action.response.data;

  return {
    ...state,
    token,
    user: { id, name, email, accessProfile },
    isImpersonating: isImpersonating || false,
    originalUser: originalUser || null,
  };
};


const loginSuccessCase = (state, action) => {
  const {
    id,
    name,
    email,
    accessProfile,
    token,
    isImpersonating,
    originalUser,
  } = action.response.data;

  return {
    token,
    user: { id, name, email, accessProfile },
    isLoggingIn: false,
    isImpersonating: isImpersonating || false,
    originalUser: originalUser || null,
  };
};


const loginFailureCase = state => ({
  ...state,
  isLoggingIn: false,
});

const logoutCase = () => initialState;

const apiCallFailureCase = (state, action) => {
  const { httpStatus } = action.response;
  if (httpStatus === 401) {
    return initialState;
  }
  return state;
};

const meUpdatedCase = state => ({
  ...state,
  /* TODO: atualizar quando meus dados são atualizados
  user: {
    name: action.response.data.entities.employee.name,
    email: action.response.data.email,
    accessProfile: action.response.data.accessProfile,
  },
  */
});

const sessionReducer = createReducer(initialState, {
  [types.LOGIN_REQUEST]: loginRequestCase,
  [types.LOGIN_SUCCESS]: loginSuccessCase,
  [types.LOGIN_FAILURE]: loginFailureCase,
  [types.LOGOUT]: logoutCase,
  [types.API_CALL_FAILURE]: apiCallFailureCase,
  [types.ME_UPDATED]: meUpdatedCase,
  [types.FETCH_CURRENT_USER_SUCCESS]: fetchCurrentUserSuccess,
});

export const getToken = state => state.session.token;
export const isLoggedIn = state => !!getToken(state);
export const isLoggingIn = state => state.session.isLoggingIn;
export const getLoggedUser = state => state.session.user || {};
export const getLoggedUserName = state => {
  return getLoggedUser(state).name;
};
export const getLoggedUserFirstName = state => getLoggedUserName(state).split(' ')[0];
export const getAccessProfile = state => getLoggedUser(state).accessProfile;
export const getAbility = state => abilities[getAccessProfile(state)] || abilities.Visitante;
export const isImpersonating = state => state.session.isImpersonating;
export const getOriginalUser = state => state.session.originalUser;
export const getLoggedUserId = state => getLoggedUser(state).id;

export default sessionReducer;


// import types from '../actions/types';
// import abilities from '../abilities';
// import createReducer from '../utils/createReducer';
// import { stopImpersonation } from 'utils/impersonation';
// import { Ability, AbilityBuilder } from '@casl/ability';
// import abilityDefinitions from '../abilities';

// const initialState = {
//   token: null,
//   isLoggingIn: false,
//   user: {
//     name: 'Visitante',
//     email: 'Visitante',
//     accessProfile: 'Visitante',
//   },
//   isImpersonating: false,
//   originalUser: null,
// };

// const loginRequestCase = state => ({
//   ...state,
//   isLoggingIn: true,
// });

// const loginSuccessCase = (state, action) => ({
//   token: action.response.data.token,
//   user: {
//     id: action.response.data.id,
//     name: action.response.data.name,
//     email: action.response.data.email,
//     accessProfile: action.response.data.accessProfile,
//   },
//   isLoggingIn: false,
// });

// const loginFailureCase = state => ({
//   ...state,
//   isLoggingIn: false,
// });

// const fetchCurrentUserSuccess = (state, action) => ({
//   ...state,
//   user: {
//     id: action.response.data.id,
//     name: action.response.data.name,
//     email: action.response.data.email,
//     accessProfile: action.response.data.accessProfile,
//   },
//   isImpersonating: action.response.data.isImpersonating || false,
//   originalUser: action.response.data.originalUser || null,
// });

// const logoutCase = () => initialState;

// const apiCallFailureCase = (state, action) => {
//   const { httpStatus } = action.response;
//   if (httpStatus === 401) {
//     return initialState;
//   }
//   return state;
// };

// const meUpdatedCase = state => ({
//   ...state,
//   /* TODO: atualizar quando meus dados são atualizados
//   user: {
//     name: action.response.data.entities.employee.name,
//     email: action.response.data.email,
//     accessProfile: action.response.data.accessProfile,
//   },
//   */
// });

// const sessionReducer = createReducer(initialState, {
//   [types.LOGIN_REQUEST]: loginRequestCase,
//   [types.LOGIN_SUCCESS]: loginSuccessCase,
//   [types.LOGIN_FAILURE]: loginFailureCase,
//   [types.LOGOUT]: logoutCase,
//   [types.API_CALL_FAILURE]: apiCallFailureCase,
//   [types.ME_UPDATED]: meUpdatedCase,
//   [types.FETCH_CURRENT_USER_SUCCESS]: fetchCurrentUserSuccess,
// });

// export const getToken = state => state.session.token;
// export const isLoggedIn = state => !!getToken(state);
// export const isLoggingIn = state => state.session.isLoggingIn;
// export const isImpersonating = state => state.session.isImpersonating;
// export const getOriginalUser = state => state.session.originalUser;
// export const getLoggedUser = state => state.session.user || {};
// export const getLoggedUserName = state => getLoggedUser(state).name;
// export const getLoggedUserFirstName = state => getLoggedUserName(state).split(' ')[0];
// export const getAccessProfile = state => {
//   // console.log('getLoggedUser(state)', getLoggedUser(state));
//   // console.log('getLoggedUser(state).accessProfile', getLoggedUser(state).accessProfile);
//   // console.log('state.session.originalUser', state.session.originalUser);
  
  
//   return getLoggedUser(state).accessProfile;
// }

// // export const getAbility = (state) => {
// //   const role = getAccessProfile(state);
// //   const ability = (abilityDefinitions[role] || abilityDefinitions.Visitante)();
// //   return ability; // já é um Ability
// // };

// export const getAbility = state => abilities[getAccessProfile(state)] || abilities.Visitante;

// export default sessionReducer;
